import { createContext, useContext, type Dispatch, type SetStateAction } from 'react'

export type SidebarState = 'expanded' | 'collapsed'

export type SidebarContextValue = {
  state: SidebarState
  open: boolean
  persistedOpen: boolean
  setOpen: (value: SetStateAction<boolean>) => void
  setOpenOnFocus: (value: boolean) => void
  setOpenOnHover: (value: boolean) => void
  closeSidebarUntilHoverReset: () => void
  hoverOpen: boolean
  focusOpen: boolean
  isMobile: boolean
  openMobile: boolean
  setOpenMobile: Dispatch<SetStateAction<boolean>>
  toggleSidebar: () => void
}

// Keep context identity outside the refreshable sidebar component module so Vite HMR cannot
// temporarily pair a previous provider with newly refreshed consumers.
const SidebarContext = createContext<SidebarContextValue | null>(null)

function useSidebar(): SidebarContextValue {
  const context = useContext(SidebarContext)

  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider.')
  }

  return context
}

export { SidebarContext, useSidebar }
